import { ArrowRight, Users } from 'lucide-react'
import useStore from '@/stores/useStore'
import { Button } from '@/components/ui/button'
import { formatCurrency } from '@/lib/utils'

export default function OnboardingStepResults({ onShowCensus, onShowResults, onChooseAnother }) {
  const metrics = useStore((state) => state.analysis.planA.metrics)
  const isEstimate = useStore((state) => state.workspaceMode === 'estimate')

  if (!metrics) return null

  const cashBalanceEnabled = metrics.cashBalanceEnabled === true

  return (
    <div className="space-y-6 text-center">
      <div className="space-y-2">
        <h1 className="text-balance text-2xl font-semibold text-foreground">
          Estimated Annual Employer Contributions
        </h1>
        <p className="text-sm text-muted-foreground">
          {isEstimate
            ? 'Based on modeled workforce assumptions.'
            : 'Based on the current employee data and plan design.'}
        </p>
      </div>

      <div className="mx-auto max-w-md space-y-3 rounded-lg border border-border bg-card/80 px-6 py-8">
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {cashBalanceEnabled ? 'Defined-Contribution Portion' : 'Employer Contributions'}
        </p>
        <p className="text-4xl font-semibold tabular-nums text-foreground">
          {formatCurrency(metrics.totalEmployerContributions)}
        </p>
        <p className="text-xs text-muted-foreground">
          {metrics.totalEmployees} employee{metrics.totalEmployees === 1 ? '' : 's'}, {' '}
          {Math.round(metrics.participationRate)}% participating
        </p>
        {cashBalanceEnabled && (
          <div className="mt-5 border-t border-border pt-5">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Estimated Cash-Balance Benefits
            </p>
            <p className="mt-2 text-2xl font-semibold tabular-nums text-foreground">
              {formatCurrency(metrics.totalCashBalanceHypotheticalCredits ?? 0)}
            </p>
            <p className="mt-2 text-xs leading-5 text-muted-foreground">
              Benefit credits are not required deposits. Formal plan pricing requires an administrator quote;
              funding requires an enrolled actuary.
            </p>
          </div>
        )}
      </div>

      <div className="space-y-3">
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button type="button" variant="outline" size="lg" onClick={onShowCensus}>
            <Users className="mr-2 h-4 w-4" aria-hidden="true" />
            Review Employees
          </Button>
          <Button type="button" size="lg" onClick={onShowResults}>
            Open Full Results
            <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
          </Button>
        </div>
        <button
          type="button"
          onClick={onChooseAnother}
          className="text-xs text-muted-foreground underline underline-offset-2 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          Choose a Different Starting Option
        </button>
      </div>
    </div>
  )
}
